import script from "./CollectedInvoiceShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectedInvoiceShow.vue?vue&type=script&setup=true&lang=js"

import "./CollectedInvoiceShow.vue?vue&type=style&index=0&id=3e56107f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e56107f"]])

export default __exports__